import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import { DynamicsEntityDataset } from 'app/model/dataset/dynamics-entity.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsEntityDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                entityName: '*'
            }
        }
    }
})
export class DynamicsEntityDatasetAdapter extends TabularTypeDatasetAdapter<DynamicsEntityDataset, Model.DatasetResource> {
    protected async _toResource(dataset: DynamicsEntityDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(DynamicsEntityDataset).name, 'entityName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DynamicsEntityDataset): Promise<DynamicsEntityDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, DynamicsEntityDataset.MODEL, 'entityName');
    }
}
